export const constants = {
  ROOM_FEATURES_CODES: ['C2', 'R1', 'V9', 'Y2', 'F2', 'B5'],
  STAY_CODES: ['E1'],
  BATHROOM_CODES: ['E6'],
  FEATHER_CODES: ['V9', 'B5'],
  FEATHER_PILLOW_CODE: 'V9',
  PILLOW_CODES: ['V9', 'F2', 'Y2'],
  HOUSEKEEPING_OPT_IN: 'J9',
  HOUSEKEEPING_CODES: ['J8', 'J9'],
  HOUSEKEEPING_OPT_OUT: 'J8',
  MARRIOTT_BRAND_CODE: 'MC',

  // Housekeeping codes
  HK_EXCLUDED_BRAND_LIST: ['ER', 'MV', 'RZ', 'EB', 'WH', 'LC', 'XR', 'JW', 'BG', 'RS', 'SN'],

  // brands that need to redirected to the landing page instead of the reviews page
  HWSLandingPageRedirectionBrands: ['RZ', 'MV', 'DS', 'BG'],

  // Room Preferences Codes
  PREFERENCES_EXCEPTION_CODE: ['S5', 'D7', 'D9', 'N8', 'U2', 'W5', 'N2', 'M2'],
  ROOM_LOCATIONS_CODES: ['H1', 'L2', 'N1'],
  FLOOR_CODES: ['L2', 'H1'],

  ADDITIONAL_RF: 'RF',

  PLUS_PAYMENT_METHOD_CODE_TYPE: '25.PMT',
  PAYMENT_METHOD_CODE_TYPE_DEPOSITE: '1.PMT,4.PMT,8.PMT',
  PAYMENT_METHOD_CODE_TYPE_GUARANTEE: '2.PMT,3.PMT,5.PMT,19.PMT,22.PMT,25.PMT,29.PMT,30.PMT,32.PMT,40.PMT',
  DEFAULT_PMT: '5.PMT',

  HOTEL_ICON_CODES: {
    HOTEL_SERVICES: 'SA',
    HOTEL_HIGHLIGHTS: 'HH',
    PARKING: 'PT',
    HOUSEKEEPING: '10',
  },
  GUEST_ROOM_FIELD: 'rooms.guests',

  // New Error framework
  EAPI_ERROR_CODES: [
    119,
    163,
    213,
    217,
    240,
    241,
    242,
    262,
    299,
    313,
    352,
    365,
    389,
    506,
    630,
    647,
    648,
    'AP10071',
    'AP10076',
    'AP10077',
    'E_ALREADY_CANCELLED',
    'E_ALREADY_CONFIRMED',
    'E_ARRIVAL_FORMAT',
    'E_BAD_CONF_NO',
    'E_BAD_HSSMMP_ID',
    'E_BAD_IATA',
    'E_BAD_IATAN_VER',
    'E_DOUBLE_CLICK',
    'E_FRAUD_ALERT',
    'E_INVALID_KEY',
    'E_MAX_BOOKINGS',
    'E_MAX_BOOK_ARRIVAL',
    'E_NO_CERTS_LEFT',
    'E_REPEATED_HOTEL',
    'E_TOO_MANY_NIGHTS',
  ],
};
